import { motion } from "framer-motion";
import { stats } from "../../data/resume";

export const StatsBar = () => {
  return (
    <section
      data-testid="stats-section"
      className="border-y border-hair bg-surface2"
    >
      <div className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              data-testid={`stat-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="border-b sm:border-b-0 border-hair py-8 lg:py-10 sm:border-r last:border-r-0 sm:[&:nth-child(2)]:border-r-0 lg:[&:nth-child(2)]:border-r sm:pr-6 sm:first:pl-0 lg:pl-6 lg:first:pl-0"
            >
              <div className="font-serif text-4xl lg:text-5xl text-ink leading-none">
                {s.value}
              </div>
              <div className="mt-3 font-mono text-xs uppercase tracking-[0.18em] text-inkmuted">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
